import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  getviewSettingsTerminalLHSApi,
  getViewSettingsTerminalRHSApi,
} from "../Api";
import DualListBox from 'react-dual-listbox';
import 'react-dual-listbox/lib/react-dual-listbox.css';

const Transfer = (props) => {
  const [availableColumns , setAvailableColumns] = useState([])
  const [selectedColumns , setSelectedColumns] = useState([])
    const [pending, setPending] = React.useState(true);


  useEffect(() => {

      //console.log("=-=-=-=-=-=-=-=-=-=- ",props.viewID.value)
    const fetchRhsList = async () => {
      const result = await axios.get(`${getViewSettingsTerminalRHSApi}?paramUserViewID=${props?.viewID?.value}`);
      const arr =[]
      result.data.response.map((item,index)=>(arr.push(item.terminalColumnID)));
        result.data.response.map((item,index)=>setAvailableColumns(old=>[...old,{value:item.terminalColumnID,label:item.terminalColumnName}]))

        setSelectedColumns(arr)
    };
      const fetchLhsList = async () => {
          const result = await axios.get(`${getviewSettingsTerminalLHSApi}?paramUserViewID=${props?.viewID?.value}`);
          //console.log(result.data.response,"result")
          result.data.response.map((item,index)=>setAvailableColumns(old=>[...old,{value:item.terminalColumnID,label:item.terminalColumnName}]))

      };
      setPending(false)
    fetchLhsList();
    fetchRhsList();
    return () => {
      setAvailableColumns([]);
      setSelectedColumns([]);
    };
  }, [props.viewID]);
  const handleSaveView=async()=>{
      //console.log('availableColumns ',availableColumns)
      console.log('selectedColumns ',selectedColumns)
    // here call the Api for save
  }
  const handleDeleteView=async()=>{

    // here call the Api for deletion
  }

    if(pending){
        return <div className="spinner-container">
            <div className="loading-spinner">
            </div>
        </div>
    }
  return (
    <div>
      <div className="row">
        <div className="col col-md-9">
          <DualListBox canFilter
                       options={availableColumns} showHeaderLabels={true} showNoOptionsText={true} availableHeader={'mine'} selected={selectedColumns} onChange={e=>setSelectedColumns(e)}/>
        </div>
        <div className="col col-md-3">
          <strong>Basic Rules are :</strong>
          <h6><i>* The Global Views cannot be Updated or deleted </i></h6>
          <h6><i>
            * All the views have the following fields in consecutive order: Error
            Status, Cash status and terminalID</i>
          </h6>
        </div>
        {/*  */}
      </div>
      <div
        className="row d-flex mt-4 align-items-center"
        style={{ marginLeft: "20%" }}
      >
        <span class="input-group-text" role="button" onClick={() =>handleSaveView()}>
          Save View
        </span>
        <span class="input-group-text ml-4" role="button" onClick={() => handleDeleteView()}>
          Delete View
        </span>
      </div>
    </div>
  );
};

export default Transfer;
